
import { defineComponent, ref, reactive } from 'vue';
import { Timer } from '@element-plus/icons'
export default defineComponent({
    components: {
Timer

    },
    setup () {

        return {


        };
    },
});
